export function isWebEnvironment() {
  return typeof document != 'undefined';
}
